import React from 'react';
import { motion } from 'framer-motion';
const stats = ['+240 pág.', '60+ herramientas'];
const tags = ['Evaluación', 'Motivación', 'Recaídas', 'Vínculos', 'Autocuidado', 'Familia', 'Fichas', 'Protocolos', 'Preguntas', 'Registro', 'Circuito', 'Prevención', 'Lenguaje rioplatense', 'Contexto argentino'];
const situations = ['Primera conversación difícil', 'Persona que no quiere cambiar', 'Negación total', 'Recaída reciente', 'Familia que sabotea', 'Desgaste del orientador', 'Pensamientos automáticos', 'Disparadores de juego', 'Vacío post-juego', 'Cierre del acompañamiento'];
export function StatsBanner() {
  return <section className="py-10 md:py-20 px-4 bg-navy-dark text-cream-bg" data-id="element-321">
      <div className="max-w-6xl mx-auto" data-id="element-322">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-8" data-id="element-323">
          <h2 className="font-serif text-2xl md:text-4xl font-bold mb-2" data-id="element-324">
            SISTEMA N°1 PARA ORIENTADORES EN ADICCIONES
          </h2>
          <p className="text-cream-bg/80 text-sm md:text-base" data-id="element-325">
            ideahubdigital.online — Sistema completo · 6 Volúmenes + 6 Bonos
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-326">
          {stats.map((stat, index) => <span key={index} className="bg-gold text-navy-dark font-bold px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm" data-id="element-327">
              {stat}
            </span>)}
        </div>

        <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-6 md:mb-8" data-id="element-328">
          {tags.map((tag, index) => <span key={index} className="bg-navy-base border border-gold/30 px-2 py-1 md:px-3 md:py-1 rounded-full text-[10px] md:text-xs" data-id="element-329">
              {tag}
            </span>)}
        </div>

        <p className="text-center mb-4 md:mb-6 text-cream-bg/90 text-sm md:text-base" data-id="element-330">
          Funciona desde hoy en tu ONG, centro de día, comunidad terapéutica o
          práctica independiente.
        </p>

        <div data-id="element-331">
          <p className="text-center font-semibold mb-3 md:mb-4 text-sm md:text-base" data-id="element-332">
            Situaciones que resuelve:
          </p>
          <div className="flex flex-wrap justify-center gap-1.5 md:gap-2" data-id="element-333">
            {situations.map((situation, index) => <span key={index} className="bg-navy-base/50 border border-cream-bg/20 px-2 py-1 md:px-3 md:py-1 rounded text-[10px] md:text-xs" data-id="element-334">
                {situation}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}